import { useRef, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export default function Gallery({ images }) {
  const trackRef = useRef(null);
  const [index, setIndex] = useState(0);

  const goTo = (i) => {
    const track = trackRef.current;
    if (!track) return;
    const clamped = Math.max(0, Math.min(images.length - 1, i));
    track.scrollTo({ left: clamped * track.clientWidth, behavior: 'smooth' });
    setIndex(clamped);
  };

  const onScroll = () => {
    const track = trackRef.current;
    if (!track) return;
    setIndex(Math.round(track.scrollLeft / track.clientWidth));
  };

  return (
    <div className="relative h-full">
      <div
        ref={trackRef}
        onScroll={onScroll}
        data-testid="why-photo-gallery"
        className="no-scrollbar flex h-[460px] w-full snap-x snap-mandatory overflow-x-auto scroll-smooth lg:h-[620px]"
      >
        {images.map((img) => (
          <img
            key={img.src}
            src={img.src}
            alt={img.alt}
            draggable="false"
            className={`h-full w-full shrink-0 snap-center select-none object-cover ${img.pos || 'object-center'}`}
          />
        ))}
      </div>

      {images.length > 1 && (
        <>
          <button
            data-testid="gallery-prev"
            onClick={() => goTo(index - 1)}
            aria-label="Previous photo"
            className={`absolute left-4 top-1/2 -translate-y-1/2 grid place-items-center h-11 w-11 rounded-full bg-white/90 text-navy shadow-lift transition-all hover:bg-white hover:scale-105 ${index === 0 ? 'opacity-0 pointer-events-none' : ''}`}
          >
            <ChevronLeft size={20} />
          </button>
          <button
            data-testid="gallery-next"
            onClick={() => goTo(index + 1)}
            aria-label="Next photo"
            className={`absolute right-4 top-1/2 -translate-y-1/2 grid place-items-center h-11 w-11 rounded-full bg-white/90 text-navy shadow-lift transition-all hover:bg-white hover:scale-105 ${index === images.length - 1 ? 'opacity-0 pointer-events-none' : ''}`}
          >
            <ChevronRight size={20} />
          </button>
          <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex items-center gap-2 z-10">
            {images.map((_, i) => (
              <button
                key={i}
                data-testid={`gallery-dot-${i}`}
                onClick={() => goTo(i)}
                aria-label={`Go to photo ${i + 1}`}
                className={`h-2.5 rounded-full transition-all duration-300 ${i === index ? 'w-6 bg-white' : 'w-2.5 bg-white/50 hover:bg-white/80'}`}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
}
